<template>
  <v-flex data-qa="consentpreview-flex-izcol">
    <Modal
      :config="getVerifyPersonalDetailsConfig"
      @btn2Action="updatePersonalDetails"
      @btn1Action="openReviewTermsAndCondition">
      <template slot="modalContent">
        <v-row no-gutters class="pt-4">
          <font class="body-2 text--secondary">
            {{ $t('termsAndConditions.verifyInfoDetails') }}
          </font>
        </v-row>
        <v-row no-gutters class="pt-4">
          <font class="body-2 text--secondary">
            {{ $t('termsAndConditions.infoText') }}
          </font>
        </v-row>
        <v-row no-gutters>
          <font class="body-2 text--secondary">
            <span class="font-weight-bold">{{ $t('termsAndConditions.nameLabel') }} </span> {{ customerDetails.fullName }}
          </font>
        </v-row>
        <v-row no-gutters>
          <font class="body-2 text--secondary">
            <span class="font-weight-bold">{{ $t('termsAndConditions.dobLabel') }} </span> {{ this.$formatter.formatDate(customerDetails.dateOfBirth) }}
          </font>
        </v-row>
        <v-row no-gutters>
          <font class="body-2 text--secondary">
            <span class="font-weight-bold">{{ $t('termsAndConditions.addressLabel') }} </span> {{ addressDetails?.addressLine1 || 'N/A'}} {{ addressDetails?.addressLine2 }} {{ addressDetails?.townOrCity }} {{ addressDetails?.postCode }}
          </font>
        </v-row>
        <v-row no-gutters class="pb-4">
          <font class="body-2 text--secondary">
            <span class="font-weight-bold">{{ $t('termsAndConditions.nationalityLabel') }} </span> {{ customerDetails.countryCitizenDescription || 'N/A' }}
          </font>
        </v-row>
      </template>
    </Modal>
    <Modal
      :config="errorOnProceedModalConfig"
      @btn1Action="$router.push('/home')">
      <template slot="modalContent">
        <v-row no-gutters class="pt-2">
          <font class="body-2 text--secondary">
            {{ $t('termsAndConditions.unabletoProceed') }}
          </font>
          <!-- commenting as part of customization req -->
          <!-- <p class="text-body-2 mb-0 pt-2">
            <v-icon>mdi-circle-small</v-icon> {{ $t('termsAndConditions.needUpdateAddress') }}
          </p>
          <p class="text-body-2 mb-0 pb-2">
            <v-icon>mdi-circle-small</v-icon> {{ $t('termsAndConditions.needUpdateOthers') }}
          </p> -->
        </v-row>
      </template>
    </Modal>
  </v-flex>
</template>

<script>
import store from '@/core/store'

export default {
  name: 'PersonalDetailsAndConsent',
  components: {
    Modal: () => import('@/components/common/Modal.vue')
  },
  data () {
    return {
      verifyInfoModalConfig: {
        enabled: true,
        persistent: true,
        close: true,
        cancelCallback: this.onCancel,
        btn2Label: this.$t('termsAndConditions.actions.needUpdate'),
        btn1Label: this.$t('termsAndConditions.actions.noChanges'),
        title: this.$t('termsAndConditions.verifyInfoTitle'),
        width: 600
      },
      errorOnProceedModalConfig: {
        enabled: false,
        persistent: true,
        close: true,
        title: this.$t('termsAndConditions.updateRequiredTitle'),
        width: 600,
        btn1Label: this.$t('common.goToDashboardBtnLabel')
      }
    }
  },
  created () {
    const { customerDetails, originalResidentialAddr } = store.getters['profileStore/profileData']
    this.customerDetails = customerDetails
    this.addressDetails = originalResidentialAddr
  },
  computed: {
    getVerifyPersonalDetailsConfig () {
      return {
        ...this.verifyInfoModalConfig,
        enabled: true
      }
    }
  },
  methods: {
    updatePersonalDetails () {
      this.errorOnProceedModalConfig.enabled = true
    },
    onCancel () {
      this.$emit('cancel', true)
    },
    openReviewTermsAndCondition () {
      this.$emit('continue', true)
    }
  }
}

</script>
